
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33742',
  depVersions: {
  "documents-public-ui": "static-1.33742",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33747",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1818",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5291",
  "hs-test-utils": "static-1.7681",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11124",
  "I18n": "static-7.1541",
  "jasmine-immutable": "static-1.2717",
  "jasmine-runner": "static-1.6153",
  "lodash": "static-1.3",
  "quartz": "static-1.6583",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16332",
  "reporting-data": "static-1.66102",
  "reporting-testing-lib": "static-1.8035",
  "reporting-visualizations": "static-1.58178",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4445",
  "webpack-env": "static-1.54",
  "atom": "static-1.4772",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2164",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.698",
  "customer-data-filters-ui": "static-1.38536",
  "customer-data-objects": "static-1.7312",
  "customer-data-property-utils": "static-1.7770",
  "data-fetching-client": "static-1.9374",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4235",
  "flux-actions": "static-1.297",
  "FormsCommonComponents": "static-1.85005",
  "FormUrlGenerator": "static-2.4431",
  "foundations-components": "static-1.7306",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11432",
  "icons": "static-2.613",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6843",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3559",
  "property-translator": "static-1.5113",
  "quartz-config": "static-1.361",
  "quartz-core": "static-1.5802",
  "quick-fetch": "static-1.3637",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5085",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7860",
  "reference-resolvers-lite": "static-1.7791",
  "report-customization-components": "static-1.12232",
  "reporting-enablement": "static-1.21759",
  "reporting-reports": "static-1.65780",
  "reporting-snowflake": "static-1.54720",
  "reporting-ui-components": "static-2.63374",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4304",
  "sales-content-partitioning": "static-1.8634",
  "SalesContentIndexUI": "static-3.8745",
  "sanitize": "static-1.4175",
  "sanitize-text": "static-1.7841",
  "self-service-api": "static-1.9925",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1457",
  "signup-constants": "static-1.18210",
  "signup-ui-lego-core": "static-1.20220",
  "signup-ui-url-generator": "static-2.7731",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4473",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10697",
  "ui-addon-i18n": "static-1.10828",
  "ui-addon-react-router-dom": "static-1.9248",
  "ui-addon-upgrades": "static-9.17421",
  "ui-asset-management-lib": "static-1.10560",
  "ui-images": "static-2.1062",
  "UIComponents": "static-3.8071",
  "usage-tracker": "static-1.7036",
  "usage-tracker-container": "static-1.7026",
  "usage-tracker-core": "static-1.6886",
  "usage-tracker-public": "static-1.6847",
  "viral-links-lib": "static-1.6720",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3135",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2860",
  "quartz-webpack": "static-1.2807",
  "ai-components-ui-library": "static-1.8098",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4531",
  "foundations-theming": "static-1.4102",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4722",
  "foundations-theming-base": "static-1.3087",
  "HeadJS": "static-2.690",
  "framer-motion": "static-1.65",
  "hs-test-utils-bend-plugin": "static-1.2792",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4031",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7624",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3368",
  "persist-promise": "static-1.3386",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9128",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9214",
  "hubspotter-http": "static-1.4387",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6951",
  "crm-message-bus": "static-1.42104",
  "customer-data-filters-ui-msw-helpers": "static-1.20970",
  "customer-data-objects-ui-components": "static-1.12702",
  "customer-data-reference-ui-components": "static-1.12838",
  "customer-data-ui-utilities": "static-1.9526",
  "framework-builder-read-service-client": "static-1.3756",
  "framework-data-schema-quick-fetch": "static-1.6472",
  "framework-data-schema-resolvers": "static-1.6567",
  "inbound-db-properties-service-client": "static-1.3587",
  "multi-account-reference-resolvers": "static-1.666",
  "onboarding-tours": "static-1.16132",
  "reporting-datasets-permissions-lib": "static-1.12721",
  "ui-addon-teams": "static-1.21091",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67319",
  "customer-data-properties": "static-1.50494",
  "forms-ai-lib": "static-1.3842",
  "forms-utils-lib": "static-1.11979",
  "foundations-components-test-utils": "static-1.4789",
  "react-dnd-compat": "static-1.4324",
  "react-tinymce": "static-1.54361",
  "tinymce-config": "static-2.53487",
  "ui-gdpr-components": "static-1.10046",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3575",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.980",
  "ui-fonts": "static-1.386",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.770",
  "mobile-manifest-mixins": "static-1.463",
  "quartz-auth": "static-1.258",
  "quartz-head": "static-1.248",
  "quartz-i18n": "static-1.258",
  "quartz-test": "static-1.258",
  "batch-promise": "static-1.1229",
  "external-options-client-types": "static-1.3891",
  "react-colorpicker": "static-2.9913",
  "copilot-toolkit": "static-1.10289",
  "data-quality-ui-library": "static-1.12100",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40433",
  "reporting-insights-lib": "static-1.889",
  "reporting-plugins": "static-1.9858",
  "ui-addon-draggable-compat": "static-2.3954",
  "ui-addon-opt": "static-4.8090",
  "ui-shepherd-react": "static-3.9843",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24457",
  "hubspot-apollo-client": "static-1.4581",
  "sales-templates-service-types-lib": "static-1.3902",
  "ui-business-units-lib": "static-1.8721",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5331",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3812",
  "upgrade-management-service-types": "static-1.4208",
  "timezone-utils": "static-2.4945",
  "bender-build-tools": "static-1.2805",
  "chatspot-core": "static-1.19959",
  "chirp-fetch": "static-1.1582",
  "bend-plugin-foundations-theming": "static-1.2585",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3531",
  "crm-pipelines-api-client-types": "static-1.3873",
  "multi-currency-client-types": "static-1.3430",
  "getting-started-shared-tasks": "static-1.17603",
  "growth-data-modal": "static-1.5031",
  "growth-onboarding-confetti": "static-1.2751",
  "growth-onboarding-next-action-utils": "static-1.1195",
  "navigation-components": "static-1.16980",
  "onboarding-tours-client": "static-1.4346",
  "onboarding-tours-utils": "static-1.198",
  "ui-shepherd-tracker": "static-1.7224",
  "ui-universal-auth": "static-1.8558",
  "user-context": "static-1.4794",
  "cms-field-types": "static-1.4508",
  "content-icons-ui": "static-1.2117",
  "integrations-lib": "static-1.15097",
  "calling-global-api": "static-1.63314",
  "calling-internal-common": "static-1.30989",
  "calling-lifecycle-internal": "static-1.64696",
  "calling-lifecycle-messages": "static-1.56990",
  "commerce-products-lib": "static-1.8553",
  "crm-links": "static-1.5953",
  "file-manager-components": "static-1.22582",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.353",
  "inbounddb-objects-service-types": "static-1.3958",
  "meetings-icalendar-utils-lib": "static-1.334",
  "object-builder-ui-client": "static-1.47659",
  "pipeline-validation-client-types": "static-1.3694",
  "property-value-citations": "static-1.1108",
  "pulse": "static-1.191",
  "smart-property-lib": "static-1.5530",
  "tiered-pricing": "static-1.667",
  "ui-addon-iframeable": "static-1.8716",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19289",
  "tinymce-themes": "static-1.55457",
  "data-token-picker": "static-1.15887",
  "hub-http-contrib": "static-1.2748",
  "interframe": "static-3.4493",
  "tinymce-data": "static-1.39572",
  "tinymce-plugins": "static-1.56601",
  "ui-addon-sales-email": "static-1.4914",
  "hubspotter-http-shared-msw-handlers": "static-1.9212",
  "magpie-lib": "static-1.5276",
  "magpie-types": "static-1.4736",
  "simple-logging-lib": "static-1.2751",
  "content-assistance-lib": "static-1.7304",
  "dashboard-lib": "static-1.80224",
  "ExportDialog": "static-6.10089",
  "hubspot-prosemirror": "static-1.17338",
  "hubspot-prosemirror-plugins": "static-1.17330",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8387",
  "campaign-roi-lib": "static-1.7987",
  "feedback-loader": "static-1.28677",
  "commerce-analytics-service-client": "static-1.3388",
  "onboarding-scopes": "static-1.6144",
  "apollo-link-hub-http": "static-2.4349",
  "hubspot-apollo-cache": "static-1.40",
  "growth-monetization-service-types": "static-1.4224",
  "nav-client-types": "static-1.2032",
  "purchase-motions-api": "static-1.5334",
  "trials-service-types": "static-1.3625",
  "chatspot-client-types": "static-1.10349",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.427",
  "getting-started-shared-tasks-store": "static-1.16721",
  "cohere-reconnect-lib": "static-1.50",
  "integrations-error-boundary-lib": "static-1.12512",
  "integrations-tracking-lib": "static-1.5284",
  "native-integrations-shared-strings": "static-1.7488",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10074",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30995",
  "shared-worker-versioning": "static-1.10717",
  "calling-usage-tracker": "static-1.6239",
  "calling-orchestration-shared-library": "static-1.34508",
  "customer-data-tracking": "static-1.6561",
  "products-iframe-lib": "static-1.7081",
  "products-ui-components-shared-msw-handlers": "static-1.9596",
  "location-customization-utils-lib": "static-1.8245",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3857",
  "video-components-external": "static-1.10265",
  "video-data-lib": "static-1.33923",
  "directed-graph": "static-1.638",
  "event-emitter": "static-1.625",
  "breeze-intelligence-kit": "static-1.5170",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9297",
  "fsm": "static-1.3431",
  "policy-lib": "static-1.6502",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9360",
  "navigation-messaging": "static-1.6307",
  "FileManagerLib": "static-1.38222",
  "NamespacedHubStyle": "static-2.8808",
  "FileManagerCore": "static-1.38081",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11858",
  "layout-dnd-utils": "static-1.10833",
  "react-codemirror": "static-1.10304",
  "ui-addon-emoji-picker": "static-1.9590",
  "ui-brand-identity-lib": "static-1.13428",
  "ui-addon-video-player": "static-1.8421",
  "ui-coaching-tips": "static-1.27677",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8267",
  "payment-link-components": "static-1.22658",
  "EmailSignatureEditor": "static-1.23746",
  "eligibility-engine-service-types": "static-1.2906",
  "universal-page-editor-lib": "static-1.2697",
  "calling-orchestration-schema": "static-1.34733",
  "sales-views-client-types": "static-1.3993",
  "crm-record-cards-service-types": "static-1.3361",
  "content-media-composition-data-lib": "static-1.11036",
  "content-media-compositions": "static-2.15043",
  "media-bridge-lib": "static-1.18405",
  "trellis-story-utils": "static-1.4223",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5467",
  "FileManagerImages": "static-1.35733",
  "video-components": "static-1.12268",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4234",
  "video-embed": "static-1.34757",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67394",
  "layout-data-lib": "static-1.9158",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6286",
  "commerce-tours-lib": "static-1.5564",
  "growth-onboarding-reliability": "static-1.4788",
  "sales-checkout-service-client": "static-1.3400",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21128",
  "sales-email-signature-service-client": "static-1.3541",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21119",
  "outpost": "static-1.3913",
  "advanced-menus-core": "static-1.14652",
  "advanced-menus-lib": "static-1.11643",
  "ui-memberships-settings-lib": "static-1.33162",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14651",
  "simple-menus-lib": "static-1.16168"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33742",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33747",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1818",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5291",
  "hs-test-utils": "/hs-test-utils/static-1.7681",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11124",
  "I18n": "/I18n/static-7.1541",
  "jasmine-immutable": "/jasmine-immutable/static-1.2717",
  "jasmine-runner": "/jasmine-runner/static-1.6153",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6583",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16332",
  "reporting-data": "/reporting-data/static-1.66102",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8035",
  "reporting-visualizations": "/reporting-visualizations/static-1.58178",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4445",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4772",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2164",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.698",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38536",
  "customer-data-objects": "/customer-data-objects/static-1.7312",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7770",
  "data-fetching-client": "/data-fetching-client/static-1.9374",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4235",
  "flux-actions": "/flux-actions/static-1.297",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85005",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4431",
  "foundations-components": "/foundations-components/static-1.7306",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11432",
  "icons": "/icons/static-2.613",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6843",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3559",
  "property-translator": "/property-translator/static-1.5113",
  "quartz-config": "/quartz-config/static-1.361",
  "quartz-core": "/quartz-core/static-1.5802",
  "quick-fetch": "/quick-fetch/static-1.3637",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5085",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7860",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7791",
  "report-customization-components": "/report-customization-components/static-1.12232",
  "reporting-enablement": "/reporting-enablement/static-1.21759",
  "reporting-reports": "/reporting-reports/static-1.65780",
  "reporting-snowflake": "/reporting-snowflake/static-1.54720",
  "reporting-ui-components": "/reporting-ui-components/static-2.63374",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4304",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8634",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8745",
  "sanitize": "/sanitize/static-1.4175",
  "sanitize-text": "/sanitize-text/static-1.7841",
  "self-service-api": "/self-service-api/static-1.9925",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1457",
  "signup-constants": "/signup-constants/static-1.18210",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20220",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7731",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4473",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10697",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10828",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9248",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17421",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10560",
  "ui-images": "/ui-images/static-2.1062",
  "UIComponents": "/UIComponents/static-3.8071",
  "usage-tracker": "/usage-tracker/static-1.7036",
  "usage-tracker-container": "/usage-tracker-container/static-1.7026",
  "usage-tracker-core": "/usage-tracker-core/static-1.6886",
  "usage-tracker-public": "/usage-tracker-public/static-1.6847",
  "viral-links-lib": "/viral-links-lib/static-1.6720",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3135",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2860",
  "quartz-webpack": "/quartz-webpack/static-1.2807",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8098",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4531",
  "foundations-theming": "/foundations-theming/static-1.4102",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4722",
  "foundations-theming-base": "/foundations-theming-base/static-1.3087",
  "HeadJS": "/HeadJS/static-2.690",
  "framer-motion": "/framer-motion/static-1.65",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2792",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4031",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7624",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3368",
  "persist-promise": "/persist-promise/static-1.3386",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9128",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9214",
  "hubspotter-http": "/hubspotter-http/static-1.4387",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6951",
  "crm-message-bus": "/crm-message-bus/static-1.42104",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20970",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12702",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12838",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9526",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3756",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6472",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6567",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3587",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.666",
  "onboarding-tours": "/onboarding-tours/static-1.16132",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12721",
  "ui-addon-teams": "/ui-addon-teams/static-1.21091",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67319",
  "customer-data-properties": "/customer-data-properties/static-1.50494",
  "forms-ai-lib": "/forms-ai-lib/static-1.3842",
  "forms-utils-lib": "/forms-utils-lib/static-1.11979",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4789",
  "react-dnd-compat": "/react-dnd-compat/static-1.4324",
  "react-tinymce": "/react-tinymce/static-1.54361",
  "tinymce-config": "/tinymce-config/static-2.53487",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10046",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3575",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.980",
  "ui-fonts": "/ui-fonts/static-1.386",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.770",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.463",
  "quartz-auth": "/quartz-auth/static-1.258",
  "quartz-head": "/quartz-head/static-1.248",
  "quartz-i18n": "/quartz-i18n/static-1.258",
  "quartz-test": "/quartz-test/static-1.258",
  "batch-promise": "/batch-promise/static-1.1229",
  "external-options-client-types": "/external-options-client-types/static-1.3891",
  "react-colorpicker": "/react-colorpicker/static-2.9913",
  "copilot-toolkit": "/copilot-toolkit/static-1.10289",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12100",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40433",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.889",
  "reporting-plugins": "/reporting-plugins/static-1.9858",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3954",
  "ui-addon-opt": "/ui-addon-opt/static-4.8090",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9843",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24457",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4581",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3902",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8721",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5331",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3812",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4208",
  "timezone-utils": "/timezone-utils/static-2.4945",
  "bender-build-tools": "/bender-build-tools/static-1.2805",
  "chatspot-core": "/chatspot-core/static-1.19959",
  "chirp-fetch": "/chirp-fetch/static-1.1582",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2585",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3531",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3873",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3430",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17603",
  "growth-data-modal": "/growth-data-modal/static-1.5031",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2751",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1195",
  "navigation-components": "/navigation-components/static-1.16980",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4346",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.198",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7224",
  "ui-universal-auth": "/ui-universal-auth/static-1.8558",
  "user-context": "/user-context/static-1.4794",
  "cms-field-types": "/cms-field-types/static-1.4508",
  "content-icons-ui": "/content-icons-ui/static-1.2117",
  "integrations-lib": "/integrations-lib/static-1.15097",
  "calling-global-api": "/calling-global-api/static-1.63314",
  "calling-internal-common": "/calling-internal-common/static-1.30989",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64696",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56990",
  "commerce-products-lib": "/commerce-products-lib/static-1.8553",
  "crm-links": "/crm-links/static-1.5953",
  "file-manager-components": "/file-manager-components/static-1.22582",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.353",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3958",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.334",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47659",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3694",
  "property-value-citations": "/property-value-citations/static-1.1108",
  "pulse": "/pulse/static-1.191",
  "smart-property-lib": "/smart-property-lib/static-1.5530",
  "tiered-pricing": "/tiered-pricing/static-1.667",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8716",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19289",
  "tinymce-themes": "/tinymce-themes/static-1.55457",
  "data-token-picker": "/data-token-picker/static-1.15887",
  "hub-http-contrib": "/hub-http-contrib/static-1.2748",
  "interframe": "/interframe/static-3.4493",
  "tinymce-data": "/tinymce-data/static-1.39572",
  "tinymce-plugins": "/tinymce-plugins/static-1.56601",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4914",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9212",
  "magpie-lib": "/magpie-lib/static-1.5276",
  "magpie-types": "/magpie-types/static-1.4736",
  "simple-logging-lib": "/simple-logging-lib/static-1.2751",
  "content-assistance-lib": "/content-assistance-lib/static-1.7304",
  "dashboard-lib": "/dashboard-lib/static-1.80224",
  "ExportDialog": "/ExportDialog/static-6.10089",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17338",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17330",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8387",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7987",
  "feedback-loader": "/feedback-loader/static-1.28677",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3388",
  "onboarding-scopes": "/onboarding-scopes/static-1.6144",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4349",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.40",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4224",
  "nav-client-types": "/nav-client-types/static-1.2032",
  "purchase-motions-api": "/purchase-motions-api/static-1.5334",
  "trials-service-types": "/trials-service-types/static-1.3625",
  "chatspot-client-types": "/chatspot-client-types/static-1.10349",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.427",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16721",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.50",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12512",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5284",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7488",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10074",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30995",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10717",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6239",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34508",
  "customer-data-tracking": "/customer-data-tracking/static-1.6561",
  "products-iframe-lib": "/products-iframe-lib/static-1.7081",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9596",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8245",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3857",
  "video-components-external": "/video-components-external/static-1.10265",
  "video-data-lib": "/video-data-lib/static-1.33923",
  "directed-graph": "/directed-graph/static-1.638",
  "event-emitter": "/event-emitter/static-1.625",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5170",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9297",
  "fsm": "/fsm/static-1.3431",
  "policy-lib": "/policy-lib/static-1.6502",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9360",
  "navigation-messaging": "/navigation-messaging/static-1.6307",
  "FileManagerLib": "/FileManagerLib/static-1.38222",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8808",
  "FileManagerCore": "/FileManagerCore/static-1.38081",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11858",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10833",
  "react-codemirror": "/react-codemirror/static-1.10304",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9590",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13428",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8421",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27677",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8267",
  "payment-link-components": "/payment-link-components/static-1.22658",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23746",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2906",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2697",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34733",
  "sales-views-client-types": "/sales-views-client-types/static-1.3993",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3361",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11036",
  "content-media-compositions": "/content-media-compositions/static-2.15043",
  "media-bridge-lib": "/media-bridge-lib/static-1.18405",
  "trellis-story-utils": "/trellis-story-utils/static-1.4223",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5467",
  "FileManagerImages": "/FileManagerImages/static-1.35733",
  "video-components": "/video-components/static-1.12268",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4234",
  "video-embed": "/video-embed/static-1.34757",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67394",
  "layout-data-lib": "/layout-data-lib/static-1.9158",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6286",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5564",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4788",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3400",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21128",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3541",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21119",
  "outpost": "/outpost/static-1.3913",
  "advanced-menus-core": "/advanced-menus-core/static-1.14652",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11643",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14651",
  "simple-menus-lib": "/simple-menus-lib/static-1.16168"
}
};
